import { render, staticRenderFns } from "./UnitItem.vue?vue&type=template&id=21f8de41&scoped=true&"
import script from "./UnitItem.vue?vue&type=script&lang=js&"
export * from "./UnitItem.vue?vue&type=script&lang=js&"
import style0 from "./UnitItem.vue?vue&type=style&index=0&id=21f8de41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f8de41",
  null
  
)

export default component.exports